import React, { Fragment } from 'react'
import { NextPage } from 'next'
import PublicLayout from 'src/components/Layout/public'
import Container from 'src/components/Common/Container'
import { Section } from 'src/components/Common/Section'
import { useTranslation } from 'react-i18next'
import { Title } from 'src/components/Common'
import { colors } from 'src/theme/colors'
import { Content, Paragraph } from 'src/components/Faq/styles'
import TitleWrapper from 'src/components/Common/TitleWrapper'
import { apiPublic } from 'src/service/api/api.public'
import { FaqApi } from 'src/service/api/api.types'
import { FaqSkeleton } from 'src/components/Skeleton/faq'

const Faq: NextPage = () => {
  const { t } = useTranslation()

  const [faqSections, setFaqSections] = React.useState<FaqApi>()

  React.useEffect(() => {
    ;(async () => {
      await getFaq()
    })()
  }, [])

  async function getFaq() {
    const res = await apiPublic.getFaq()
    if (res.kind === 'ok') {
      setFaqSections(res.data)
    }
  }

  return (
    <PublicLayout>
      <TitleWrapper>
        <Title
          borderMargin="medium"
          size="lg"
          borderColor={colors.palette.white}
          tx={t('faq.title')}
          theme="light"
        />
      </TitleWrapper>
      <Container>
        {faqSections ? (
          <Content>
            {faqSections.map(faqSection => (
              <Section
                key={faqSection.id}
                titleTx={faqSection.title}
                preset="faqTitle"
                padding="0.5rem 0"
                paddingMobile="0.7rem 0.3rem"
              >
                {faqSection.faq.map(faqItem => (
                  <Fragment key={faqItem.id}>
                    <Paragraph className="question">{faqItem.question}</Paragraph>
                    <Paragraph>{faqItem.answer}</Paragraph>
                  </Fragment>
                ))}
              </Section>
            ))}
          </Content>
        ) : (
          <FaqSkeleton />
        )}
      </Container>
    </PublicLayout>
  )
}

export default Faq
